module.exports = __webpack_public_path__ + "res/Roboto-CondensedItalic-webfontd41d.eot?80de7bf784c2263b3fe8c08580104df9";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-CondensedItalic-webfontd41d.eot
// module id = 42
// module chunks = 0